const init = { groupId: '', groupTitle: '' };
const initLs = JSON.parse(localStorage.getItem('groupSelectedInfo'));

let selectedGroup = {};

if (localStorage.getItem('groupSelectedInfo') === null) {
  selectedGroup = init;
} else {
  selectedGroup = initLs;
}

export default {
  namespaced: true,

  // = data
  state: {
    groupSelectedInfo: Object.assign({}, selectedGroup),
  },

  mutations: {
    SET_GROUP_SELECTED_INFO(state, payload) {
      state.groupSelectedInfo = payload;
    },
    RESET_GROUP_SELECTED_INFO(state, payload) {
      state.groupSelectedInfo = payload;
    },
  },

  // = methods
  actions: {
    setGroupSelectedInfo({ commit }, payload) {
      commit('SET_GROUP_SELECTED_INFO', payload);
    },
    resetGroupSelectedInfo({ commit }) {
      commit('SET_GROUP_SELECTED_INFO', Object.assign({}, init));
      localStorage.removeItem('groupSelectedInfo');
    },
  },

  // = computed properties
  getters: {
    groupSelectedInfo: state => state.groupSelectedInfo,
  },
};
